// Services
import api from '../../services/api';

const state = {
  searchResults: null,
  searchError: null,
  selectedShopper: null,
  selectedAction: null,
  dropoffDonateRemaining: false,
  selectedBinNumber: null,
  isNewShopper: null,
  config: null,
  tradeOffer: null,
  buyTradeOffer: null,
};

const getters = {
  searchResults: (state) => state.searchResults,
  searchError: (state) => state.searchError,
  selectedShopper: (state) => state.selectedShopper,
  selectedAction: (state) => state.selectedAction,
  dropoffDonateRemaining: (state) => state.dropoffDonateRemaining,
  selectedBinNumber: (state) => state.selectedBinNumber,
  isNewShopper: (state) => state.isNewShopper,
  shopperConfig: (state) => state.config,
  tradeOffer: (state) => state.tradeOffer,
  buyTradeOffer: (state) => state.buyTradeOffer,
};

const actions = {
  // Searches shopper
  search: ({ commit }, data) =>
    new Promise(async (resolve, reject) => {
      try {
        commit('setSearchError', false);
        const { data: respData, status } = await api({
          url: `/api/shopper/?search=${data.searchTerm}`,
          method: 'GET',
        });
        if (status !== 200) {
          commit('setSearchError', true);
          return resolve();
        }
        commit('setSearchResults', respData);
        resolve(respData);
      } catch (e) {
        reject(e);
      }
    }),

  // Gets a shopper by ID
  get: ({ commit }, data) =>
    new Promise(async (resolve, reject) => {
      try {
        const { data: respData, status } = await api({
          url: `/api/shopper/${data}/`,
          method: 'GET',
        });
        if (status !== 200) {
          return resolve();
        }
        commit('storeShopper', respData);
        resolve(respData);
      } catch (e) {
        reject(e);
      }
    }),

  // Stores selected shopper
  storeSelected: ({ commit }, shopper) => commit('storeShopper', shopper),

  // Store selection of customer for 'Instore Waitlist' or 'Dropoff'
  selectAction: ({ commit }, action) => commit('selectAction', action),

  // state of dropoffDonateRemaining if true, the swapper's unwanted items will be donated
  // action is true or false
  setDonateRemaining: ({ commit }, action) => commit('setDonateRemaining', action),

  // Store BIN number of customer item
  selectBinNumber: ({ commit }, binNumber) =>
    commit('selectBinNumber', binNumber),

  // Stores shopper config
  storeConfig: ({ commit }, config) => commit('storeConfig', config),

  // Stores shopper config
  removeSelectedShopper: ({ commit }) => commit('removeStoredShopper'),

  // Edits shopper
  save: ({ commit }, shopper) =>
    new Promise(async (resolve, reject) => {
      try {
        const { status } = await api({
          url: `/api/shopper/${shopper.id}/`,
          method: 'PUT',
          data: shopper,
        });
        if (status !== 200) {
          return reject();
        }
        resolve();
      } catch (e) {
        reject(e);
      }
    }),

  isNewShopper: ({ commit }, isNewShopper) =>
    commit('isNewShopper', isNewShopper),

  // Creates shopper
  create: ({ commit }, shopper) =>
    new Promise(async (resolve, reject) => {
      try {
        const { status, data } = await api({
          url: '/api/shopper/',
          method: 'POST',
          data: shopper,
        });
        if (status !== 201) {
          return reject();
        }
        resolve(data);
      } catch (error) {
        reject(error);
      }
    }),

  createTransaction: ({ commit }, { action, id, binNumber, isNewShopper, selectedTagIds }) =>
    new Promise(async (resolve, reject) => {
      // try {
      //   const { status, data } = await api({
      //     url: '/api/transaction/',
      //     method: 'POST',
      //     data: {
      //       shopper: id,
      //       action,
      //     },
      //   });
      //   if (status !== 201) {
      //     return reject();
      //   }
      //   resolve(data);
      // } catch (e) {
      //   reject(e);
      // }

      try {
        const { status, data } = await api({
          url: '/api/transaction/print-receipt/',
          method: 'POST',
          data: {
            shopper: id,
            tag_ids: selectedTagIds,
            action,
            binNumber,
            isNewShopper,
          },
        });
        if (status !== 201) {
          // return reject();
        }
        resolve(data);
      } catch (e) {
        reject(e);
      }

      return 0;
    }),

  getTradeOfferDetails: ({ commit }, id) =>
    new Promise(async (resolve, reject) => {
      console.log(id);

      try {
        const { data: respData, status } = await api({
          url: `/api/trade-offer/${id}/`,
          method: 'GET',
        });
        if (status !== 200) {
          return resolve();
        }
        commit('storeTradeOffer', respData);
        resolve(respData);
      } catch (e) {
        reject(e);
      }
    }),

  signTradeOffer: ({ commit }, { id, signature }) =>
    new Promise(async (resolve, reject) => {
      try {
        const { status } = await api({
          url: `/api/trade-offer/${id}/sign/`,
          method: 'POST',
          data: {
            signature,
          },
          timeout: 15000,
        });
        if (status !== 200) {
          return reject();
        }
        resolve();
      } catch (e) {
        reject(e);
      }
    }),

  getBuyTradeOfferDetails: ({ commit }, id) =>
    new Promise(async (resolve, reject) => {
      console.log(id);

      try {
        const { data: respData, status } = await api({
          url: `/api/buy-trade-offer/${id}/`,
          method: 'GET',
        });
        if (status !== 200) {
          return resolve();
        }
        commit('storeBuyTradeOffer', respData);
        resolve(respData);
      } catch (e) {
        reject(e);
      }
    }),

  signBuyTradeOffer: ({ commit }, { id, signature }) =>
    new Promise(async (resolve, reject) => {
      try {
        const { status } = await api({
          url: `/api/buy-trade-offer/${id}/sign/`,
          method: 'POST',
          data: {
            signature,
          },
          timeout: 15000,
        });
        if (status !== 200) {
          return reject();
        }
        resolve();
      } catch (e) {
        reject(e);
      }
    }),

  checkBin: ({ commit }, binNumber) => 
    new Promise(async (resolve, reject) => {
      try {
        const response = await api({
          url: `/api/buy/check-bin/`,
          method: 'POST',
          data: {
            bin_number: binNumber,
          },
        });

        resolve(response);
      } catch (e) {
        reject(e);
      }
    }),
};

const mutations = {
  setSearchResults: (state, data) => {
    state.searchResults = data;
  },
  setSearchError: (state, value) => {
    state.searchError = value;
  },
  selectAction: (state, data) => {
    state.selectedAction = data;
  },
  setDonateRemaining: (state, data) => {
    state.dropoffDonateRemaining = data;
  },
  selectBinNumber: (state, data) => {
    state.selectedBinNumber = data;
  },
  isNewShopper: (state, data) => {
    state.isNewShopper = data;
  },
  storeShopper: (state, data) => {
    if (state.selectedShopper) {
      // Update current shopper
      state.selectedShopper = { ...state.selectedShopper, ...data };
    } else {
      // Stores the shopper
      state.selectedShopper = data;
    }
  },
  storeTradeOffer: (state, data) => {
    state.tradeOffer = data;
  },
  storeBuyTradeOffer: (state, data) => {
    state.buyTradeOffer = data;
  },
  storeConfig: (state, data) => {
    state.config = data;
  },
  removeStoredShopper: (state) => {
    state.selectedShopper = null;
  },
};

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions,
};
